import ApiClient from "../helpers/ApiClient";


export const createGalleryAlbum = async ({ album_name }) => {
    try {
        const response = await ApiClient.post(`/homePage/homePage/addAlbum`, { album_name });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getGalleryAlbumData = async () => {
    try {
        const response = await ApiClient.get(`/homePage/homePage/getAlbum`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addImageData = async ({ album_id, file }) => {
    try {
        const response = await ApiClient.post(`/homePage/homePage/addImages`,
            {  album_id, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                    
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteImageData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/homePage/homePage/deleteImages/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/homePage/homePage/deleteImages/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteAlbumData = async ({ id }) => {
    try {
        const response = await ApiClient.put(`/homePage/homePage/deleteAlbum/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const createVideoGalleryAlbum = async ({ album_name }) => {
    try {
        const response = await ApiClient.post(`/galleryAndNews/addVideoAlbum`, { album_name });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getVideoGalleryAlbumData = async () => {
    try {
        const response = await ApiClient.get(`/galleryAndNews/getVideoAlbum`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addVideoData = async (data) => {
    try {
        const response = await ApiClient.post(`/galleryAndNews/addVideo`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteVideoData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/galleryAndNews/deleteVideos/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteVideoAlbumData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/galleryAndNews/deleteVideoAlbum/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}